/** Only navigate to HTTP(S) images or same-origin absolute paths. */
export function imageLink(url: string | undefined): string | undefined {
  if (!url || /[\s\\]/.test(url)) return undefined;
  return /^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url) ? url : undefined;
}
